export default __webpack_public_path__ + "static/e-card-2f58d8cff5d77ef2d28aba6c4643d6d5.png";